import React from "react";
import { Button } from "primereact/button";

interface ResultsProps {
  onBack: () => void;
}

const Results = ({ onBack }: ResultsProps) => {
  return (
    <div>
      <h2>Results</h2>
      <div className="p-d-flex p-jc-start mt-4">
        <Button
          id="apres-btn-back"
          data-testid="apres-btn-back"
          label="Back"
          icon="pi pi-arrow-left"
          onClick={onBack}
          className="p-button-secondary"
        />
      </div>
    </div>
  );
};

export default Results;
